module.exports = __webpack_public_path__ + "static/media/f3.13476a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f3.png
// module id = 1214
// module chunks = 0